<template>
  <div>
    <h2 class="title">复制门店数据</h2>
    <a-row :gutter="20" style="margin-bottom: 10px;">
      <a-col :span="8">
        <h3 class="item-tit">
          源门店列表
          <a-input-search
            placeholder="名称/编码"
            enter-button="搜索"
            @search="onSearch($event, 1)"
          />
        </h3>
        <div class="item-content">
          <a-radio-group
            v-model="orginShop"
            @change="onChange"
            class="radio-box"
          >
            <template v-for="item in originData">
              <p class="g-title" v-if="item.CompanyList.length" :key="item.Id">
                {{ item.GroupName
                }}<span v-if="item.GroupCode">({{ item.GroupCode }})</span>
              </p>
              <a-radio
                :style="radioStyle"
                v-for="company in item.CompanyList"
                :value="company.Id"
                :key="company.Id"
              >
                {{ company.Name
                }}<span style="color:#666" v-if="company.Code"
                  >（{{ company.Code }}）</span
                >
              </a-radio>
            </template>
          </a-radio-group>
        </div>
      </a-col>
      <a-col :span="8">
        <h3 class="item-tit">
          目标门店列表
          <a-input-search
            placeholder="名称/编码"
            enter-button="搜索"
            @search="onSearch($event, 2)"
          />
        </h3>
        <div class="item-content">
          <a-radio-group
            v-model="targetShop"
            @change="onChange"
            class="radio-box"
          >
            <template v-for="item in targetData">
              <p class="g-title" v-if="item.CompanyList.length" :key="item.Id">
                {{ item.GroupName
                }}<span v-if="item.GroupCode">({{ item.GroupCode }})</span>
              </p>
              <a-radio
                :style="radioStyle"
                v-for="company in item.CompanyList"
                :value="company.Id"
                :key="company.Id"
              >
                {{ company.Name
                }}<span style="color:#666" v-if="company.Code"
                  >（{{ company.Code }}）</span
                >
              </a-radio>
            </template>
          </a-radio-group>
        </div>
      </a-col>
      <a-col :span="8">
        <h3 class="item-tit">参数配置</h3>
        <div class="item-content" style="padding:10px 15px">
          <div
            :style="{
              borderBottom: '1px solid #E9E9E9',
              paddingBottom: '10px'
            }"
          >
            <a-checkbox
              :indeterminate="indeterminate"
              :checked="checkAll"
              @change="onCheckAllChange"
            >
              全选
            </a-checkbox>
          </div>
          <a-checkbox-group
            v-model="checkedList"
            @change="onChangeConfig"
            class="check-cnt"
          >
            <a-checkbox
              v-for="(item1, index) in configOptions"
              :key="index"
              :value="item1.value"
              >{{ item1.label }}</a-checkbox
            >
          </a-checkbox-group>
        </div>
      </a-col>
    </a-row>
    <div class="btm-btns">
      <a-button class="left-btn" type="danger" @click="removeCopyData"
        >移除复制数据</a-button
      >
      <a-button class="left-btn" @click="$router.push({ name: 'ShopManage' })"
        >返回</a-button
      >
      <a-button type="primary" @click="onSubmit">保存</a-button>
      <a-button @click="resetData">重置</a-button>
    </div>
    <a-modal
      title="移除复制数据"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :destroyOnClose="true"
      :maskClosable="false"
      @ok="confirmDelete"
      @cancel="visible = false"
    >
      <a-form :form="form" :layout="formLayout">
        <a-form-item label="移除门店">
          <a-select
            style="width:200px"
            v-decorator="[
              'CompanyId',
              { rules: [{ required: true, message: '请选择移除门店' }] }
            ]"
          >
            <a-select-opt-group v-for="item in shopOptions" :key="item.Id">
              <span slot="label">{{ item.GroupName }}</span>
              <a-select-option
                v-for="company in item.CompanyList"
                :value="company.Id"
                :key="company.Id"
              >
                {{ company.Name }}
              </a-select-option>
            </a-select-opt-group>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import cloneDeep from "lodash/cloneDeep";
export default {
  data() {
    return {
      orginShop: "",
      targetShop: "",
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      originData: [],
      targetData: [],
      shopOptions: [],
      checkedList: [],
      configOptions: [
        { label: "系统参数", value: "CheckSysParam" },
        { label: "报表", value: "CheckReports" },
        { label: "房态颜色", value: "CheckRoomStatusColor" },
        { label: "维修原因", value: "CheckRpepairReason" },
        { label: "班次", value: "CheckShift" },
        { label: "账项", value: "CheckAccountItem" },
        { label: "发票类别", value: "CheckInvoiceType" },
        { label: "客户类别", value: "CheckCustomerType" },
        { label: "价构", value: "CheckPriceStructure" },
        { label: "单位", value: "CheckUnit" },
        { label: "证件类型", value: "CheckIdType" },
        { label: "单据模板", value: "CheckBillTemplate" },
        { label: "间夜数", value: "CheckNightNumber" }
      ],
      indeterminate: false,
      checkAll: false,
      visible: false,
      confirmLoading: false,
      formLayout: "inline",
      form: this.$form.createForm(this, { name: "coordinated" })
    };
  },
  created() {
    this.$post("CopyData_Companys", {}).then(res => {
      this.shopOptions = res.Data;
      this.originData = cloneDeep(res.Data);
      this.targetData = cloneDeep(res.Data);
    });
    this.indeterminate = false;
    this.checkAll = true;
    this.checkedList = this.configOptions.map(v => {
      return v.value;
    });
  },
  methods: {
    onSearch: debounce(function(val, type) {
      const data = cloneDeep(this.shopOptions);
      const keyword = val ? val.trim().toLowerCase() : "";
      let list = [];
      if (keyword) {
        list = data.filter(el => {
          const name = el.GroupName ? el.GroupName.trim().toLowerCase() : "";
          const code = el.GroupCode ? el.GroupCode.trim().toLowerCase() : "";
          if (name.includes(keyword) || code.includes(keyword)) {
            return true;
          } else {
            el.CompanyList = el.CompanyList.filter(item => {
              const cname = item.Name ? item.Name.trim().toLowerCase() : "";
              const ccode = item.Code ? item.Code.trim().toLowerCase() : "";
              if (cname.includes(keyword) || ccode.includes(keyword)) {
                return true;
              }
            });
            if (el.CompanyList && el.CompanyList.length) {
              return true;
            }
            return false;
          }
        });
      } else {
        list = data;
      }
      if (type == 1) {
        this.originData = list;
      } else {
        this.targetData = list;
      }
    }, 300),
    onChange() {},
    onChangeConfig(checkedList) {
      this.indeterminate =
        !!checkedList.length && checkedList.length < this.configOptions.length;
      this.checkAll = checkedList.length === this.configOptions.length;
    },
    onCheckAllChange(e) {
      Object.assign(this, {
        checkedList: e.target.checked
          ? this.configOptions.map(v => v.value)
          : [],
        indeterminate: false,
        checkAll: e.target.checked
      });
    },
    onSubmit() {
      let params = {
        SourceCompanyId: this.orginShop,
        TargetCompanyId: this.targetShop
      };
      this.checkedList.forEach(element => {
        params[element] = true;
      });
      this.$post("CopyData_Async", params).then(() => {
        this.$message.success("操作成功！");
      });
    },
    resetData() {
      this.checkedList = [];
      this.orginShop = "";
      this.targetShop = "";
      this.indeterminate = false;
      this.checkAll = false;
    },
    removeCopyData() {
      this.visible = true;
      this.confirmLoading = false;
      this.form.resetFields();
    },
    confirmDelete() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true;
          this.$post("CopyData_Delete", { Id: values.CompanyId })
            .then(() => {
              this.$message.success("操作成功！");
              this.visible = false;
              this.confirmLoading = false;
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>
<style lang="less">
.item-content {
  margin: 0;
  // margin: 0 20px 20px;
  border: 1px solid #eee;
  border-radius: 3px;
  height: calc(100vh - 290px);
  overflow: hidden;
  overflow-y: auto;
}
.item-tit {
  // margin: 10px 20px 0;
  margin-top: 10px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #e5e5e5;
  padding: 2px 5px;
  font-size: 15px;
  height: 36px;
  .ant-input-search {
    flex: 1;
    margin-left: 100px;
  }
}
.btm-btns {
  text-align: right;
  button {
    margin-left: 20px;
  }
}
.left-btn {
  float: left;
}
.radio-box {
  width: 100%;
  .g-title {
    background: #f5f5f5;
    padding: 3px 5px;
    color: #666;
    margin-top: 12px;
    &:first-child {
      margin-top: 0;
    }
  }
  .ant-radio-wrapper {
    padding-left: 15px;
    color: #000;
  }
  .ant-radio-wrapper-checked {
    background: #d3ebff;
  }
}
.check-cnt {
  .ant-checkbox-wrapper {
    display: block;
    height: 30px;
    line-height: 30px;
    margin-left: 0;
  }
}
</style>
